import {
  Component,
  HostListener,
  ChangeDetectionStrategy,
  OnInit,
  ChangeDetectorRef,
  ViewEncapsulation,
} from '@angular/core';
import { ErrorMessagesService } from 'src/app/shared/services/full-screen-error/error-messages.service';
import { Service2siteAccessOptionsService } from '@app/shared/services/service-2site-access-options.service';
import { SCREEN_SIZES } from '@app/shared/enums/screen-size.enum';
import { HeaderDetailsApiService } from '@app/shared/components/header/services/header-details.api.service';

@Component({
  selector: 'aftp-full-screen-error-popup',
  templateUrl: './full-screen-error-popup.component.html',
  styleUrls: ['./full-screen-error-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HeaderDetailsApiService],
})
export class FullScreenErrorPopupComponent implements OnInit {
  showGoBackButton: boolean;
  isMobile: boolean;
  pageName: string;
  logoImg = '../../../../assets/images/logo.png';
  headerTitle = '';

  constructor(
    private changeDetection: ChangeDetectorRef,
    private headerDetailsApiService: HeaderDetailsApiService,
    private errorValues: ErrorMessagesService,
    private siteService: Service2siteAccessOptionsService
  ) {}

  ngOnInit(): void {
    this.setHeaderData();
    this.showGoBackButton = this.siteService.getAccessToMultipleSites();
    this.pageName = 'lp-group-restriction';
    this.isMobile = window.innerWidth < SCREEN_SIZES.mobileScreen;
  }

  setHeaderData() {
    this.headerDetailsApiService
      .getHeaderDetails()
      .subscribe(({ data: { programName } }) => {
        this.headerTitle = programName;
        this.changeDetection.detectChanges();
      });
  }
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.isMobile = window.innerWidth < SCREEN_SIZES.mobileScreen;
  }
}
